import React, { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Form } from "react-bootstrap";
import { toast } from "react-toastify";
import {
  commonPostPutApi,
  commonPostPutApi1,
} from "../../../redux/reducers/commonApiSlice";
import { showConfirmAlert } from "../../components-react/ReactAlert";
import CommonHeadingNBtns from "../../common-components/CommonHeadingNBtns";
import SelectDropdown from "../../components-react/SelectDropdown";
import {
  add_feature_grouping,
  map_feature_group_with_user,
} from "../../../data/ApiEndpoints";
import { selectGymData } from "../../../redux/reducers/gymDataSlice";
import { fetchGymData } from "../../../data/APIs";
import MultiSelect from "../../components-react/MultiSelect";
import { all_account_types } from "../../common-data/DropdowData";
import { fetchInHouseUsersData } from "../../../redux/reducers/dropdownApiSlice";
import {
  fetchDashboardFeatureGroupingdata,
  fetchDashboardFeaturesdata,
  fetchUserMappedFeatureData,
} from "../../../redux/dashboard-features/featuresSlice";

function validateForm(formValues, isEdit, name) {
  let errors = {};

  if (!isEdit && formValues.selectedUser?.length === 0) {
    errors.selectedUser = `required!`;
  }

  if (name === "add-to-group" && !formValues.selectedFeatureGroup) {
    errors.selectedFeatureGroup = `required!`;
  }

  if (name === "create-new-group" && formValues.checkedPages?.length === 0) {
    errors.checkedPages = `required!`;
  }

  // if (name === "create-new-group" && !formValues.groupName) {
  //   errors.groupName = `required!`;
  // }

  return errors;
}

const PageMappingForm = ({
  userInfoData,
  closeModal,
  callFunction,
  isEdit,
  rowData,
}) => {
  const dispatch = useDispatch();
  const { inhouseUsers, loading } = useSelector((state) => state.dropdown);
  const { postPutLoading, postPutLoading1 } = useSelector(
    (state) => state.common
  );
  const {
    dashboardFeatures,
    dashboardFeaturesLoading,
    dashboardFeaturesError,

    userMappedFeatures,
    userMappedFeaturesLoading,
    userMappedFeaturesError,

    dashFeatureGrouping,
  } = useSelector((state) => state.features);

  const gymData = useSelector(selectGymData);
  const [allDashMenus, setAllDashMenus] = useState([]);
  // const [filteredDashMenus, setFilteredDashMenus] = useState([]);
  const [featureGroups, setFeatureGroups] = useState([]);
  const iniFormvalues = {
    selectedGym: "",
    selectedAccountType: "",
    selectedUser: [],
    checkedPages: [],
    selectedFeatureGroup:
      isEdit &&
      !rowData?.is_user_specific &&
      rowData?.feature_group_id &&
      rowData?.feature_group_name
        ? { value: rowData.feature_group_id, label: rowData.feature_group_name }
        : "",
    groupName: "",
  };
  const [formValues, setFormValues] = useState(iniFormvalues);
  const [selectAll, setSelectAll] = useState(false);
  const [formErrors, setFormErrors] = useState({});
  const [searchString, setSearchString] = useState("");
  const [searchFilterApplied, setSearchFilterApplied] = useState(false);
  const [allMappedPages, setAllMappedPages] = useState([]);

  const onChangeInput = (e) => {
    const { id, checked } = e.target;

    setFormValues((prevs) => {
      let updatedCheckedPages;

      if (checked) {
        updatedCheckedPages = [...prevs.checkedPages, id];
      } else {
        updatedCheckedPages = prevs.checkedPages.filter(
          (pageId) => pageId !== id
        );
      }

      setSelectAll(updatedCheckedPages.length === allDashMenus.length);

      return {
        ...prevs,
        checkedPages: updatedCheckedPages,
      };
    });
  };

  const onChangeDropdown = (name, value) => {
    if (name === "selectedGym") {
      setFormValues((prevs) => ({
        ...prevs,
        selectedAccountType: "",
        selectedUser: [],
        [name]: value,
      }));
    } else if (name === "selectedAccountType") {
      setFormValues((prevs) => ({
        ...prevs,
        selectedUser: [],
        [name]: value,
      }));
    } else {
      setFormValues((prevs) => ({
        ...prevs,
        [name]: value,
      }));
    }
  };

  const handleSelectAll = () => {
    if (selectAll) {
      const filteredIds = filteredDashMenus.map((item) => item.uid);
      setFormValues((prevs) => ({
        ...prevs,
        checkedPages: prevs.checkedPages.filter(
          (pageId) => !filteredIds.includes(pageId)
        ),
      }));
    } else {
      const filteredIds = filteredDashMenus.map((item) => item.uid);
      setFormValues((prevs) => ({
        ...prevs,
        checkedPages: [...new Set([...prevs.checkedPages, ...filteredIds])],
      }));
    }

    setSelectAll(!selectAll);
  };

  function getDashboardMenus(filters) {
    dispatch(
      fetchDashboardFeaturesdata({
        filters: filters,
        token: userInfoData?.token,
      })
    );
  }

  function getInhouseUsers() {
    dispatch(
      fetchInHouseUsersData({
        token: userInfoData?.token,
        qps: `gym_id=${formValues.selectedGym?.value || ""}&user_types=${
          formValues.selectedAccountType?.value || ""
        }`,
        pageNo: 1,
        limit: 1000,
      })
    );
  }

  function getAllMappedFeatures(filters) {
    dispatch(
      fetchUserMappedFeatureData({
        filters: filters,
        token: userInfoData?.token,
      })
    );
  }

  function getDashboardFeatureGrouping() {
    const filters = {
      page: 1,
      limit: 1000,
      status: "active",
    };

    dispatch(
      fetchDashboardFeatureGroupingdata({
        filters: filters,
        token: userInfoData?.token,
      })
    );
  }

  const handleCreateNewGroup = async (payload) => {
    const method = "POST";
    const endpoint = add_feature_grouping;
    const token = userInfoData?.token;

    try {
      const result = await dispatch(
        commonPostPutApi1({ method, endpoint, payload, token })
      );

      if (result?.payload?.status && result?.payload?.data) {
        toast.success(result?.payload?.message || "Success!");

        const usersId = formValues.selectedUser.map((item) => item?.value);
        const userData = {
          user_ids: isEdit ? [rowData?.user_id || ""] : usersId,
          group_id: result.payload.data?.uid || "",
        };

        handleAdd(userData);
      } else {
        const errorMessage = result?.error?.message || result?.payload?.message;
        toast.error(errorMessage || "Something Went Wrong!");
      }
    } catch (error) {
      console.error("Error making POST request:", error);
    }
  };

  const handleAdd = async (payload) => {
    const method = "POST";
    const endpoint = map_feature_group_with_user;
    const token = userInfoData?.token;

    try {
      const result = await dispatch(
        commonPostPutApi({ method, endpoint, payload, token })
      );

      if (result?.payload?.status) {
        toast.success(result?.payload?.message || "Success!");
        closeModal();
        callFunction();
      } else {
        const errorMessage = result?.error?.message || result?.payload?.message;
        toast.error(errorMessage || "Something Went Wrong!");
      }
    } catch (error) {
      console.error("Error making POST request:", error);
    }
  };

  const onSubmit = (name) => {
    const errors = validateForm(formValues, isEdit, name);
    setFormErrors(errors);

    if (Object.keys(errors).length === 0) {
      const usersId = formValues.selectedUser?.map((item) => item?.value);

      if (name === "add-to-group") {
        const userData = {
          user_ids: isEdit ? [rowData?.user_id || ""] : usersId,
          group_id: formValues.selectedFeatureGroup?.value,
        };

        const handleConfirm = async () => {
          handleAdd(userData);
        };

        showConfirmAlert(
          handleConfirm,
          `Map Feature?`,
          "No, Edit Form",
          "Yes, Submit Form"
        );
      } else if (name === "create-new-group") {
        const userData = {
          is_user_specific: 1,
          user_ids: isEdit ? [rowData?.user_id || ""] : usersId,
          feature_ids: formValues.checkedPages || [],
        };

        const handleConfirm = async () => {
          handleAdd(userData);
        };

        showConfirmAlert(
          handleConfirm,
          `Map Feature?`,
          "No, Edit Form",
          "Yes, Submit Form"
        );
      }
      // else if (name === "create-new-group") {
      //   const userData = {
      //     name: formValues.groupName || "",
      //     default_for: formValues.selectedAccountType?.value || "",
      //     feature_ids: formValues.checkedPages || [],
      //     status: "active",
      //   };

      //   const handleConfirm = async () => {
      //     handleCreateNewGroup(userData);
      //   };

      //   showConfirmAlert(
      //     handleConfirm,
      //     `Create New Group And Map Feature?`,
      //     "No, Edit Form",
      //     "Yes, Submit Form"
      //   );
      // }
    }
  };

  useEffect(() => {
    const filters = {
      page: 1,
      limit: 1000,
      status: 1,
    };
    getDashboardMenus(filters);
    dispatch(fetchGymData(userInfoData?.token));
    getDashboardFeatureGrouping();
  }, []);

  useEffect(() => {
    if (isEdit && rowData?.user_id) {
      const sendableFilters = {
        user_id: rowData.user_id,
      };

      getAllMappedFeatures(sendableFilters);
    }
  }, []);

  useEffect(() => {
    if (
      !dashboardFeaturesLoading &&
      !dashboardFeaturesError &&
      dashboardFeatures?.status &&
      dashboardFeatures?.data?.length > 0
    ) {
      setAllDashMenus(dashboardFeatures.data);
    } else {
      setAllDashMenus([]);
    }
  }, [dashboardFeatures, dashboardFeaturesLoading, dashboardFeaturesError]);

  useEffect(() => {
    if (
      isEdit &&
      !userMappedFeaturesLoading &&
      !userMappedFeaturesError &&
      userMappedFeatures?.status &&
      userMappedFeatures?.data?.length > 0
    ) {
      const transformedData = userMappedFeatures.data?.flatMap((item) =>
        (Array.isArray(item.sub_menu) ? item.sub_menu : [])
          ?.filter((sub) => sub && typeof sub === "object")
          ?.map((sub) => ({
            ...sub,
            menu_id: item?.menu_id,
            menu_name: item?.label,
          }))
      );
      // const transformedData = userMappedFeatures.data.flatMap((item) =>
      //   item.sub_menu.map((sub) => ({
      //     ...sub,
      //     menu_id: item.menu_id,
      //     menu_name: item.label,
      //   }))
      // );

      setAllMappedPages(transformedData);
    } else {
      setAllMappedPages([]);
    }
  }, [userMappedFeatures, userMappedFeaturesLoading, userMappedFeaturesError]);

  useEffect(() => {
    if (isEdit) {
      const mappedPaths = allMappedPages?.map((page) => page.path) || [];
      const matchedPages = allDashMenus
        .filter((menu) => mappedPaths.includes(menu.route))
        .map((menu) => menu.uid);

      setFormValues((prevs) => ({
        ...prevs,
        checkedPages: matchedPages,
      }));

      setSelectAll(matchedPages.length === allDashMenus.length);
    }
  }, [allDashMenus, allMappedPages, isEdit]);

  useEffect(() => {
    getInhouseUsers();
  }, [formValues.selectedGym, formValues.selectedAccountType]);

  useEffect(() => {
    if (dashFeatureGrouping?.status && dashFeatureGrouping?.data?.length > 0) {
      const menus = dashFeatureGrouping.data.map((menu) => {
        return {
          label: menu?.name,
          value: menu?.uid,
          info: menu,
        };
      });
      setFeatureGroups(menus);
    } else {
      setFeatureGroups([]);
    }
  }, [dashFeatureGrouping]);

  const filteredDashMenus = useMemo(() => {
    if (!searchString.trim()) {
      setSearchFilterApplied(false);
      return allDashMenus;
    }

    setSearchFilterApplied(true);
    return allDashMenus.filter((menu) =>
      menu.name.toLowerCase().includes(searchString.toLowerCase())
    );
  }, [searchString, allDashMenus]);

  useEffect(() => {
    if (formValues.selectedFeatureGroup?.info) {
      const selectedFeatureIds =
        formValues.selectedFeatureGroup.info?.feature_ids?.map(
          (feature) => feature.feature_id
        ) || [];

      const defaultCheckedPages = filteredDashMenus
        .filter((menu) => selectedFeatureIds.includes(menu.uid))
        .map((menu) => menu.uid);

      setFormValues((prev) => ({
        ...prev,
        checkedPages: defaultCheckedPages,
      }));
    }
  }, [formValues.selectedFeatureGroup]);

  const sortedFilteredMenus = useMemo(() => {
    return [...filteredDashMenus].sort((a, b) => {
      const aChecked = formValues.checkedPages.includes(a.uid);
      const bChecked = formValues.checkedPages.includes(b.uid);
      return aChecked === bChecked ? 0 : aChecked ? -1 : 1;
    });
  }, [filteredDashMenus, formValues.checkedPages]);

  // useEffect(() => {
  //   if (searchString?.trim()) {
  //     const filteredMenus = allDashMenus.filter((menu) =>
  //       menu.name.toLowerCase().includes(searchString.toLowerCase())
  //     );
  //     setFilteredDashMenus(filteredMenus);
  //     setSearchFilterApplied(true);
  //   } else {
  //     setFilteredDashMenus(allDashMenus);
  //     setSearchFilterApplied(false);
  //   }
  // }, [searchString, allDashMenus]);

  // useEffect(() => {
  //   if (formValues.selectedFeatureGroup?.info) {
  //     const groupFeatures =
  //       formValues.selectedFeatureGroup.info?.feature_ids || [];
  //     const selectedFeatureIds = groupFeatures.map(
  //       (feature) => feature.feature_id
  //     );

  //     const defaultCheckedPages = filteredDashMenus
  //       .filter((menu) => selectedFeatureIds.includes(menu.uid))
  //       .map((menu) => menu.uid);

  //     setFormValues((prev) => ({
  //       ...prev,
  //       checkedPages: defaultCheckedPages,
  //     }));
  //   }

  //   const sortedMenus = [...filteredDashMenus].sort((a, b) => {
  //     const aChecked = formValues.checkedPages.includes(a.uid);
  //     const bChecked = formValues.checkedPages.includes(b.uid);

  //     return aChecked === bChecked ? 0 : aChecked ? -1 : 1;
  //   });

  //   setFilteredDashMenus(sortedMenus);
  // }, [formValues.selectedFeatureGroup]);

  // useEffect(() => {
  //   if (formValues.selectedFeatureGroup?.info) {
  //     const goupFeatures =
  //       formValues.selectedFeatureGroup.info?.feature_ids || [];

  //     const selectedFeatureIds = goupFeatures.map(
  //       (feature) => feature.feature_id
  //     );

  //     const defaultCheckedPages = filteredDashMenus
  //       .filter((menu) => selectedFeatureIds.includes(menu.uid))
  //       .map((menu) => menu.uid);

  //     setFormValues((prev) => ({
  //       ...prev,
  //       checkedPages: defaultCheckedPages,
  //     }));
  //   }
  // }, [formValues.selectedFeatureGroup, filteredDashMenus]);

  return (
    <div className="createNewCTOModalContainer mod-width-70p page-mapping-form">
      <CommonHeadingNBtns
        title="Manage Feature Mapping"
        onClose={closeModal}
        isLoading={postPutLoading || postPutLoading1}
        btnTxt="Map Group"
        onClick={() => onSubmit("add-to-group")}
        // btnTxt1="create and map new group"
        btnTxt1="map new feature"
        onClick1={() => onSubmit("create-new-group")}
      />

      <form className="formContainer">
        <div className="formInputsGrid threeGridSystem">
          {!isEdit && (
            <>
              <div className="formInputBox">
                <label htmlFor="selectedGym" className="formInputLabel">
                  Gym
                </label>

                <div
                  className={`commonWrapper ${
                    formErrors.selectedGym ? "formError" : ""
                  }`}
                >
                  <SelectDropdown
                    options={gymData}
                    selectedOption={formValues.selectedGym}
                    setSelectedOption={(selectedValue) =>
                      onChangeDropdown("selectedGym", selectedValue)
                    }
                    name="Gym"
                  />
                </div>
              </div>

              <div className="formInputBox">
                <label
                  htmlFor="selectedAccountType"
                  className={`formInputLabel `}
                >
                  Role
                </label>

                <div
                  className={`commonWrapper ${
                    formErrors?.selectedAccountType ? "formError" : ""
                  }`}
                >
                  <SelectDropdown
                    options={all_account_types}
                    selectedOption={formValues.selectedAccountType}
                    setSelectedOption={(selectedValue) =>
                      onChangeDropdown("selectedAccountType", selectedValue)
                    }
                    name="Role"
                    isDisable={postPutLoading}
                  />
                </div>
              </div>

              <div className="formInputBox">
                <label htmlFor="selectedUser" className="formInputLabel">
                  user <span className="required">*</span>
                </label>

                <div
                  className={`commonWrapper no-border multi-select ${
                    formErrors.selectedUser ? "error" : ""
                  }`}
                >
                  <MultiSelect
                    options={inhouseUsers?.length > 0 ? inhouseUsers : []}
                    state={formValues.selectedUser}
                    setState={(selectedValue) =>
                      onChangeDropdown("selectedUser", selectedValue)
                    }
                    name="select user"
                    isDisable={postPutLoading || loading}
                  />
                </div>
              </div>
            </>
          )}

          <div className="formInputBox">
            <label htmlFor="selectedFeatureGroup" className="formInputLabel">
              assign feature group{" "}
              {formErrors?.selectedFeatureGroup && (
                <span className="required">*</span>
              )}
            </label>

            <div
              className={`commonWrapper ${
                formErrors?.selectedFeatureGroup ? "formError" : ""
              }`}
            >
              <SelectDropdown
                options={featureGroups}
                selectedOption={formValues.selectedFeatureGroup}
                setSelectedOption={(selectedValue) =>
                  onChangeDropdown("selectedFeatureGroup", selectedValue)
                }
                name="feature group"
                sDisable={postPutLoading || loading}
              />
            </div>
          </div>

          {/* <div className="formInputBox">
            <label htmlFor="groupName" className={`formInputLabel`}>
              new group name
              {formErrors?.groupName && <span className="required">*</span>}
            </label>

            <input
              type="text"
              placeholder="Enter Feature Name"
              className={`formInput ${
                formErrors?.groupName ? "formError" : ""
              }`}
              name="groupName"
              value={formValues.groupName || ""}
              onChange={(e) =>
                setFormValues((prevs) => ({
                  ...prevs,
                  groupName: e.target.value,
                }))
              }
            />
          </div> */}
        </div>

        <div
          className="wFull maxWidth50VW exportablesContainer"
          style={{
            border: formErrors.checkedPages ? "2px solid red" : "",
            padding: formErrors.checkedPages ? "10px" : "",
            background: formErrors.checkedPages ? "#fff" : "",
            borderRadius: formErrors.checkedPages ? "10px" : "",
          }}
        >
          <label
            htmlFor="checkedPages"
            className="formInputLabel"
            style={{ marginBottom: "20px" }}
          >
            {isEdit ? (
              <>
                Update Accessible Pages For{" "}
                <b>
                  {`${rowData?.name}/${
                    rowData?.mobile
                  } (${rowData?.account_type?.replace(/_/g, " ")})`}
                </b>
              </>
            ) : (
              "select/deselect to create new group"
            )}{" "}
            <span className="required">*</span>
          </label>

          <div
            className={`inputCommonWrapper flexSpacebetween searchBarContainer ${
              searchFilterApplied ? "redBorderRedText" : ""
            }`}
          >
            <input
              type="search"
              className="input"
              placeholder="Search..."
              value={searchString}
              onChange={(e) => setSearchString(e.target.value)}
            />
          </div>

          {((isEdit &&
            !dashboardFeaturesLoading &&
            !userMappedFeaturesLoading) ||
            !isEdit) && (
            <div
              className="flexWrap mt30"
              style={{ gap: "2rem", width: "100%", maxWidth: "100%" }}
            >
              <Form.Check
                type="checkbox"
                id="select-all"
                label="Select All"
                checked={
                  sortedFilteredMenus.length > 0 &&
                  formValues.checkedPages.length === sortedFilteredMenus.length
                }
                onChange={handleSelectAll}
              />

              {sortedFilteredMenus.length > 0 ? (
                sortedFilteredMenus.map((field, index) => (
                  <Form.Check
                    key={index}
                    type="checkbox"
                    id={field?.uid}
                    label={field?.name}
                    checked={formValues.checkedPages.includes(field?.uid)}
                    onChange={onChangeInput}
                  />
                ))
              ) : (
                <span className="noDataFound mt30">No Fields Found</span>
              )}
            </div>
          )}

          {/* {((isEdit &&
            !dashboardFeaturesLoading &&
            !userMappedFeaturesLoading) ||
            !isEdit) && (
            <div
              className="flexWrap mt30"
              style={{ gap: "2rem", width: "100%", maxWidth: "100%" }}
            >
              <Form.Check
                type="checkbox"
                id="select-all"
                label="Select All"
                checked={
                  filteredDashMenus.length > 0 &&
                  formValues.checkedPages.length === filteredDashMenus.length
                }
                onChange={handleSelectAll}
              />

              {filteredDashMenus?.length > 0 ? (
                filteredDashMenus.map((field, index) => (
                  <Form.Check
                    key={index}
                    type={"checkbox"}
                    id={field?.uid}
                    label={field?.name}
                    checked={formValues.checkedPages.includes(field?.uid)}
                    onChange={onChangeInput}
                  />
                ))
              ) : (
                <span className="noDataFound mt30">No Fields Found</span>
              )}
            </div>
          )} */}
        </div>
      </form>
    </div>
  );
};

export default PageMappingForm;
